import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import {FormattedMessage} from "react-intl";
import Link from "@amzn/meridian/link";
import {FEATURES, HYPHEN, TRUE} from "../../constants";
import Loading from "../utils/Loading";
import ErrorPage from "../utils/ErrorPage";
import {PackageStatus} from "../../enums";
import {chainWalk, formQueryParams} from "../../Utility";
import RefreshTimer from "../RefreshTimer";
import Column from "@amzn/meridian/column";
import {getFormattedDate} from "../utils/DateTimeUtils";

/**
 * Cart View containing package information at cart level.
 */
class Cart extends Component {

    render() {

        const {loading, error, stowPackageMetricsMap} = this.props;

        if (error) return <ErrorPage errorId="stow.error" errorMessage="Some error occurred"/>;

        const allCarts = [...Object.keys(stowPackageMetricsMap)];
        const carts = [...new Set(allCarts.filter(cart => stowPackageMetricsMap[cart].currentStowedPackages > 0))].sort();

        if (loading && !carts.length) return <Loading/>;

        return (
            <Column>
                <RefreshTimer deps={[stowPackageMetricsMap]} />
                <Table headerRows={1} showDividers={false} showStripes={false} spacing="small" fixHeaderRows={true}
                       fixHeaderRowsFullWidth={true}>
                    {this.renderHeadings()}
                    {carts.map((cart) => (this.renderCartRow(cart)))}
                </Table>
            </Column>
        )
    }

    renderHeadings = () => {
        return (
            <TableRow>
                <TableCell>
                    <FormattedMessage id="cart.floor_location" defaultMessage="Floor Location"/>
                </TableCell>
                <TableCell>
                {
                    this.isReInductDatePlusOneFixEnabled() ?
                        <FormattedMessage id="cart.ofd" defaultMessage="OFD"/>
                        : <FormattedMessage id="cart.reInductDay" defaultMessage="Re-Induct Day"/>
                    }
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="cart.cart_id" defaultMessage="Cart ID"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="cart.no_of_packages" defaultMessage="# of Packages"/>
                </TableCell>
            </TableRow>
        );
    }

    renderCartRow = (cart) => {
        const combinedMetricsMap = this.getCombinedMetricsMap(cart);
        const [floorLocation, reInductDay] = this.getViewSubjects('Floor Location, Re-Induct Day');
        const cartFromCompositeKey = cart.split("|")[0];

        return (
            <TableRow highlightOnHover={true} key={cart}>
                <TableCell>{floorLocation}</TableCell>
                <TableCell>{getFormattedDate(reInductDay, this.isReInductDatePlusOneFixEnabled())}</TableCell>
                <TableCell alignmentHorizontal="right">
                    {cartFromCompositeKey}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.currentStowedPackages, cartFromCompositeKey, PackageStatus.CURRENT_STOWED,
                        floorLocation, reInductDay)}
                </TableCell>
            </TableRow>
        );
    }

    getCombinedMetricsMap = cart => ({
        currentStowedPackages: chainWalk(() => this.props.stowPackageMetricsMap[cart].currentStowedPackages, HYPHEN)
    });

    renderPackageCount = (value, cart, state, floorLocation, reInductDay) => {
        return value !== 0 && value !== HYPHEN ?
            <Link href={this.getPackageListURL(state, cart, floorLocation, reInductDay)} type="secondary">{value}</Link> : value
    }

    isSidelineViewV2Enabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.SIDELINE_STOW_V2];
    }

    isReInductDatePlusOneFixEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.REINDUCT_DATE_PLUS_ONE_FIX];
    }

    getPackageListURL = (state, cart, floorLocation, reInductDay) => {
        const params = {
            PACKAGE_STATUS: state,
            FLOOR_LOCATION: floorLocation,
            SIDELINE_UNTIL_TIME: reInductDay,
            CART: cart
        }

        if(this.isSidelineViewV2Enabled()) {
            params.SIDELINE_V2 = TRUE;
        } else {
            params.SIDELINE = TRUE;
        }

        return "#packageList/?" + formQueryParams(params);
    }

    getViewSubjects = (key) => (
        chainWalk(() => this.props.navigationOptions.find((navigationOption) => navigationOption.key === key).value, [])
    );

}

const mapStateToProps = state => ({
    loading: state.cartReducer.loading,
    error: state.cartReducer.error,
    navigationOptions: state.optionsReducerV2.navigationOptions,
    stowPackageMetricsMap: state.cartReducer.stowPackageMetricsMap,
    featureStatus: state.configReducer.featureStatus,
});

export default withRouter(connect(mapStateToProps)(Cart));



// WEBPACK FOOTER //
// ./src/components/sideline/Cart.js